var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "post-creator container" },
    [
      _c(
        "input-container",
        { staticClass: "row", on: { updateValidity: _vm.updateBaseValidity } },
        [
          _c(
            "div",
            {
              staticClass: "col-12",
              on: {
                mouseover: function($event) {
                  return _vm.lockPostInput(true)
                },
                mouseout: function($event) {
                  return _vm.lockPostInput(false)
                }
              }
            },
            [
              _c("input-image", {
                ref: "imageDropzone",
                attrs: {
                  inputName: "media",
                  id: "inputMedia",
                  expectedType: _vm.getExpectedMimeType,
                  images: _vm.editFields.media,
                  localRemove: _vm.localRemove
                },
                on: {
                  dropzoneError: _vm.dropzoneError,
                  fileChange: _vm.fileChange
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("input-text", {
                attrs: {
                  rich: _vm.rich,
                  inputName: "label",
                  variant: "standardInput",
                  stretched: "",
                  smaller: "",
                  constraints: _vm.getLabelConstraints,
                  inputPlaceholder: _vm.$t("Post.title"),
                  inputValue: _vm.getLabel
                },
                on: { fieldUpdate: _vm.fieldUpdate }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("input-textarea", {
                attrs: {
                  rich: _vm.rich,
                  inputName: "description",
                  inputPlaceholder: _vm.$t("Post.description"),
                  variant: "standardInput",
                  stretched: "",
                  constraints: _vm.getContentConstraints,
                  inputValue: _vm.getContent
                },
                on: { fieldUpdate: _vm.fieldUpdate }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("input-text", {
                attrs: {
                  inputName: "url",
                  variant: "standardInput",
                  stretched: "",
                  smaller: "",
                  constraints: _vm.getUrlConstraints,
                  inputPlaceholder: _vm.$t("URL.name"),
                  inputValue: _vm.getPostUrl
                },
                on: { fieldUpdate: _vm.fieldUpdate }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.isProduct
        ? _c(
            "div",
            { staticClass: "product-items" },
            [
              _c(
                "input-container",
                {
                  staticClass: "row",
                  on: { updateValidity: _vm.updatePriceValidity }
                },
                [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("input-number", {
                        attrs: {
                          inputName: "price",
                          variant: "standardInput",
                          stretched: "",
                          smaller: "",
                          footnote: _vm.$t("InputPost.input.price.footnote"),
                          constraints: _vm.getPriceConstraints,
                          inputPlaceholder: _vm.$t("Services.pricePlaceholder"),
                          inputValue: _vm.getPrice
                        },
                        on: { fieldUpdate: _vm.fieldUpdate }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row mt-2 mb-2" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _vm.canSetDiscount
                      ? _c("check-box", {
                          staticClass: "box-item",
                          attrs: {
                            active: { hasDiscount: _vm.hasDiscount },
                            boldLabels: "",
                            spacedLabels: "",
                            customFontSize: "13px",
                            label: _vm.$t("Services.discountPlaceholder"),
                            name: _vm.discountCheckboxLabel
                          },
                          on: { select: _vm.updateDiscountDisplay }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.hasDiscount
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "div",
                        { staticClass: "container product-discount-params" },
                        [
                          _c("input-discount", {
                            attrs: {
                              inputName: "discount",
                              inputValue: _vm.getDiscount,
                              price: _vm.getPrice,
                              canBeChanged: true
                            },
                            on: {
                              fieldUpdate: _vm.fieldUpdate,
                              updateValidity: _vm.updateDiscountValidity
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 p-0" },
                            [
                              _c("input-date-time", {
                                attrs: {
                                  inputPlaceholder: _vm.$t(
                                    "Services.discountValidToPlaceholder"
                                  ),
                                  inputName: "discountValidity",
                                  variant: "standardInput",
                                  stretched: "",
                                  smaller: "",
                                  boldPholder: "",
                                  inputValue: _vm.getDiscountValidity
                                },
                                on: { fieldUpdate: _vm.fieldUpdate }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-047652a3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-047652a3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/input/InputPost.vue
// module id = null
// module chunks = 